module.exports = __webpack_public_path__ + "img/9AI-改3_07.1a675584.jpg";